export const DragItemTypes = {
  DRSItem: "drsItem",
  CrewRow: "crewRow",
  DepotNote:"depotNote",
  ShiftCardViewItem:'shiftCardViewItem',
  ShiftCardCrewItem:'shiftCardCrewItem'
};
